import React, { useEffect, useState } from 'react';
import { FieldProps, FieldValidation } from '@rjsf/core';
import { FormControl } from '@material-ui/core';
import { useGetAPI } from '../../Utils/useGetAPI';
import {
  BackstageIdentityApi,
  microsoftAuthApiRef,
  OAuthApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
  useApi,
} from '@backstage/core-plugin-api';

import axios from 'axios';
import { Select } from '@backstage/core-components';
import Alert from '@mui/material/Alert';

type businessUnitDropdownType = {
  bu: string;
};

type optionsArrayType = [
  {
    label: string;
    value: string;
  },
];

export const BusinessUnitDropdown = ({
  // the onChange function propogates the scaffolder plugins form values with the formstate passed to it from the component.
  onChange,
}: FieldProps<string>) => {
  const [formState, setFormState] = useState<businessUnitDropdownType>({
    bu: '',
  });

  const [options, setOptions] = useState<optionsArrayType>([
    { label: 'Loading...', value: 'loading' },
  ]);
  const [error, setError] = useState<boolean>(false);

  const url: string = useGetAPI();
  const identityAPI: OAuthApi &
    OpenIdConnectApi &
    ProfileInfoApi &
    BackstageIdentityApi &
    SessionApi = useApi(microsoftAuthApiRef);

  onChange(formState);

  const getData = async () => {
    const token = await identityAPI.getIdToken();

    await axios
      .get(`${url}/v1/api/devops/businessUnits`, {
        headers: {
          Authorization: `Basic ${token}`,
        },
      })
      .then(res => {
        const repoArray =
          res !== undefined && res.data.business_units !== null
            ? res.data.business_units
            : [];

        const scrubRepoArray = Array.from(repoArray)
          .sort()
          .map(repo => {
            return {
              label: repo,
              value: repo,
            };
          });

        scrubRepoArray.unshift({
          label: 'Select a Business Unit',
          value: '',
        });

        setOptions(scrubRepoArray);
        setError(false);
      })
      .catch(e => {
        setError(true);
      });
  };

  if (options.length <= 1 && error === false) {
    getData();
  }

  return (
    <FormControl margin="normal">
      {error === false ? (
        <Select
          native
          label="Business Unit"
          onChange={selected => {
            setFormState({
              bu: selected.toString(),
            });
          }}
          items={options}
          selected={formState.bu}
        />
      ) : (
        <Alert severity="error">
          There was an issue with your request. Please wait a few minutes and
          try again.{' '}
        </Alert>
      )}
    </FormControl>
  );
};

export const businessUnitDropdownValidation = (
  value: businessUnitDropdownType,
  validation: FieldValidation,
) => {
  if (value.bu === undefined || value.bu.length < 1) {
    validation.addError('Please select a repo from the dropdown.');
  }
};
